__turbopack_context__.v({
  "buttonBase": "button-module__UhYrEW__buttonBase",
  "buttonIcon": "button-module__UhYrEW__buttonIcon",
  "buttonText": "button-module__UhYrEW__buttonText",
  "contained": "button-module__UhYrEW__contained",
  "disabled": "button-module__UhYrEW__disabled",
  "iconButton": "button-module__UhYrEW__iconButton",
  "outlined": "button-module__UhYrEW__outlined",
  "underline": "button-module__UhYrEW__underline",
});
